import React from "react";
import styles from "../daniel__adamo/sobremim_daniel__adamo.module.scss";
import { ArrowLeft } from "lucide-react";
import WhatsappIcon from "../../icons/whatsappIcon.tsx";
import MapsIcon from "../../icons/mapsIcon.tsx";
import InstagramIcon from "../../icons/instagramIcon.tsx";
import { Link } from "react-router-dom";

const Sobremim_daniel__adamo: React.FC = () => {
    return (
        <div className={styles.sobremim_daniel__adamo}>
            {/* Header */}
            <div className={styles.header}>
                <Link to="/daniel__adamo" className={styles.backButton}>
                    <ArrowLeft />
                </Link>
                <h1>Sobre mim</h1>
            </div>

            {/* Conteúdo */}
            <div className={styles.content}>
                <p>
                    Olá, meu nome é <strong>Daniel</strong>, sou advogado e sócio proprietário da <strong>Adamo & Salomão Advogados</strong>, fundado em 2013.
                </p>
                <p>
                    Minha formação não começou no diploma, começou na prática. Ainda na faculdade, atuei por <strong>quatro anos no Poder Judiciário</strong>, vivenciando de perto como o processo realmente funciona.
                </p>
                <p>
                    Sou <strong>especialista em Direito e Processo do Trabalho pela USP</strong>.
                </p>
                <p>
                    Fui <strong>conciliador e mediador no Tribunal de Justiça de São Paulo</strong>.
                </p>
                <p>
                    Também atuei na <strong>Comissão de Conciliação e Mediação da OAB Barretos, 7ª Subseção</strong>.
                </p>
                <p>
                    Ministrei aulas de cursos técnicos a pós-graduação.
                </p>
                <p>
                    Mas, acima de títulos, fiz uma escolha clara e inegociável: <strong>advogar</strong>. Por isso, afastei-me de todas as outras funções para me dedicar exclusivamente à advocacia.
                </p>
                <p>
                    Atuo predominantemente no <strong>Direito do Trabalho</strong>, com foco em <strong>acidentes e doenças do trabalho</strong>.
                </p>
                <p>
                    É assim que desde 2013 exerço a advocacia com responsabilidade e compromisso real com cada caso, já tendo atuado em mais de <strong>4 mil processos</strong>.
                </p>
                <p>
                    Para mim, <strong>cada causa vai além de um simples número</strong>.
                </p>
                <p>
                    <strong>Todo caso merece atenção máxima, estratégia e empenho total</strong>.
                </p>
                <p>
                    Vamos nessa?
                </p>
            </div>

            {/* Footer */}
            <div className={styles.footer}>
                <div className={styles.footerLinks}>
                    <a
                        href="https://www.instagram.com/daniel__adamo?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <InstagramIcon color="#DE8043" height="28" />
                    </a>
                    <a
                        href="https://maps.app.goo.gl/ZsHhCChuiD5pWZQFA"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <MapsIcon color="#DE8043" height="36" />
                    </a>
                </div>
            </div>

            {/* Botão WhatsApp flutuante */}
            <a
                href="https://wa.me/5517981339545?text=Olá! Vim pelo seu cartão digital e gostaria de mais informações..."
                className={styles.whatsappFloat}
                target="_blank"
                rel="noopener noreferrer"
            >
                <WhatsappIcon color="#fff" />
            </a>
        </div>
    );
};

export default Sobremim_daniel__adamo;
